import React from "react";
import { Clients } from "../components";

export function ClientsContainer() {
  const clientObj = [
    { icon: "/images/icons/1icon.png" },
    { icon: "/images/icons/2icon.png" },
    { icon: "/images/icons/3icon.png" },
    { icon: "/images/icons/4icon.png" },
    { icon: "/images/icons/5icon.png" },
    { icon: "/images/icons/6icon.png" },
    { icon: "/images/icons/7icon.png" },
    { icon: "/images/icons/8icon.png" },
  ];
  
  return (
    <Clients>
      <Clients.Heading>Our Clients</Clients.Heading>
      <Clients.Line/>
      <Clients.Frame>
      {clientObj.map((item) => (
        <Clients.Logo src={item.icon} />
      ))}
      </Clients.Frame> 
    </Clients>
  );
}
